module.exports = __webpack_public_path__ + "static/media/kids_37.af026ee9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_37.jpg
// module id = 5893
// module chunks = 0